import React, { Component } from "react";
import { get as _get } from "lodash";
import { injectIntl } from "react-intl";

import { RenderTableHeaderValue, RenderTableCellValue } from "../../formElements";
import { withRouter } from "../../../hoc/withRouter";
import ReactDataTable from "../../ReactDataTable";

class DataSearchTable extends Component {
  constructor(props) {
    super(props);
    const { intl } = props;

    this.searchDataTableColumns = [
      {
        name: (<RenderTableHeaderValue className="text-uppercase" value={intl.formatMessage({ id: "dataSearch.search_data.table.column.contactable", defaultMessage: "contactable" })} />),
        selector: (row) => (_get(row, "contactable", false)),
        cell: (row) => {
          return _get(row, "contactable", false) ?
            <img alt="" src={require("../../../../assets/icons/icon-circle-done.svg").default} className="img-fluid me-1" /> :
            <img alt="" src={require("../../../../assets/icons/icon-circle-close.svg").default} className="img-fluid me-1" />;
        },
        sortable: false,
        width: "110px",
        center: true
      },
      {
        name: (<RenderTableHeaderValue className="text-uppercase" value={intl.formatMessage({ id: "dataSearch.search_data.table.column.employee", defaultMessage: "employee" })} />),
        selector: (row) => (_get(row, "name", "")),
        cell: (row) => (<RenderTableCellValue value={_get(row, "name", "")} />),
        sortable: false,
        grow: 1
      },
      {
        name: (<RenderTableHeaderValue className="text-uppercase" value={intl.formatMessage({ id: "dataSearch.search_data.table.column.company", defaultMessage: "company" })} />),
        selector: (row) => (_get(row, "company", "")),
        cell: (row) => (<RenderTableCellValue value={_get(row, "company", "")} />),
        sortable: false,
        grow: 1
      },
      {
        name: (<RenderTableHeaderValue className="text-uppercase" value={intl.formatMessage({ id: "dataSearch.search_data.table.column.email", defaultMessage: "email" })} />),
        selector: (row) => (_get(row, "email", "")),
        cell: (row) => (<RenderTableCellValue value={_get(row, "email", "")} />),
        sortable: false,
        grow: 1
      },
      {
        name: (<RenderTableHeaderValue className="text-uppercase" value={intl.formatMessage({ id: "dataSearch.search_data.table.column.phone", defaultMessage: "phone" })} />),
        selector: (row) => (_get(row, "phone", "")),
        cell: (row) => (<RenderTableCellValue value={_get(row, "phone", "")} />),
        sortable: false,
        grow: 1
      },
      {
        name: (<RenderTableHeaderValue className="text-uppercase" value={intl.formatMessage({ id: "dataSearch.search_data.table.column.job_title", defaultMessage: "job title" })} />),
        selector: (row) => (_get(row, "job_title", "")),
        cell: (row) => (<RenderTableCellValue value={_get(row, "job_title", "")} />),
        sortable: false,
        grow: 1
      },
      {
        name: (<RenderTableHeaderValue className="text-uppercase" value={intl.formatMessage({ id: "dataSearch.search_data.table.column.job_seniority", defaultMessage: "job seniority" })} />),
        selector: (row) => (_get(row, "job_seniority", "")),
        cell: (row) => (<RenderTableCellValue value={_get(row, "job_seniority", "")} />),
        sortable: false,
        grow: 1
      },
    ];
  }

  render() {
    const {
      searchData,
      defaultSearchDataPayload,
      onPageChange,
      onSelectionChange
    } = this.props;

    return (
      <div className="custom-scroll">
        <ReactDataTable
          className="custom-scroll-460 leadsTable"
          columns={this.searchDataTableColumns}
          data={_get(searchData, "search_detail", [])}
          pagination={true}
          fixedHeader={false}
          totalRecords={_get(searchData, "page_info[0].total_records", 0)}
          rowsPerPage={_get(defaultSearchDataPayload, "page_size", 100)}
          selectableRows
          onChangePage={onPageChange}
          onSelectedRowsChange={(selectedRows) => {
            const tmpIds = _get(selectedRows, "selectedRows", []).map(row => row.id);
            onSelectionChange(tmpIds, selectedRows.allSelected || false);
          }}
        />
      </div>
    );
  }
}

DataSearchTable.defaultProps = {
  searchData: {},
  defaultSearchDataPayload: {},
  onPageChange: () => { },
  onSelectionChange: () => { }
};

export default withRouter(injectIntl(DataSearchTable));
